<template>
  <div v-show="dataList?.length == 0 || localSelected?.length > 0">
    <p class="bold mb-0 mt-4">
      {{ label }}
    </p>

    <div
      v-for="(check, checkIndex) in localSelected"
      :key="'check' + checkIndex"
      class="control"
    >
      <p>
        {{ check.name }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
/* */
import { PropType, computed } from 'vue';
import { OptionType, ProtocolType } from '@/config/rawdata.d';

const props = defineProps({
  label: { type: String, default: '' },
  dataList: { type: Object as PropType<Array<OptionType | ProtocolType> | null>, default: () => { return []; } },
  selected: { type: Object as PropType<Array<string> | null | undefined>, default: () => { return undefined; } }
});

const localSelected = computed(() => {
  if (!props.dataList || props.dataList.length === 0 || !Array.isArray(props.dataList)) {
    return [];
  }
  if (props.selected !== undefined) {
    return (props.dataList ?? [])?.filter(x => props.selected?.includes(x.id + ''));
  } else {
    return (props.dataList ?? [])?.filter(x => x.checked);
  }
  // return props.dataList;
});
</script>
<style lang="scss" scoped>
.bold {
  font-weight: 700;
}
.list {
  margin-left: 1rem;
}
</style>
